import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeliveryDownloadService } from '../delivery-download.service';

@Component({
  selector: 'app-delivery-download-single',
  templateUrl: './delivery-download-single.component.html',
  styleUrls: ['./delivery-download-single.component.scss'],
})
export class DeliveryDownloadSingleComponent {
  @Input() public disabled: boolean | undefined;
  @Input() public analyticsCategory: string | undefined;
  @Input() public productId: string | undefined;
  @Input() public productType: string | undefined;
  @Input() public deliveryId: string | undefined;
  @Input() public angularticsProperties: object | undefined;
  @Output() public trackDownload: EventEmitter<void> = new EventEmitter<void>();

  constructor(private _deliveryDownloadService: DeliveryDownloadService) {}

  private _isDisabled: boolean | undefined;

  public get isDisabled(): boolean {
    return this._isDisabled || this.disabled || !(this.productId && this.deliveryId);
  }

  public async download(): Promise<void> {
    this._isDisabled = true;
    try {
      this.trackDownload.emit();
      if (this.productId && this.deliveryId) {
        await this._deliveryDownloadService.downloadSingle(this.productId, this.deliveryId);
      }
    } catch (error) {
      // Optionally handle any errors that occur during the download
      console.error('Download Error:', error);
    } finally {
      this._isDisabled = false;
    }
  }
}
